export default __webpack_public_path__ + "static/qa-dfc8f92e05b6124ac69d32d1c72f4201.png";